export default __webpack_public_path__ + "static/media/3_1.2c8bcc21.jpg";